import {
    SET_DESTINATION_URGENCY_MESSAGE,
    SET_DESTINATION_INFOGRAPHIC,
    SET_LISTINGS,
    SET_UNIT_REVIEWS,
    LOADING_LISTINGS,
    FAILED_LISTINGS,
    SET_DESTINATION_IMAGES,
    SET_RECOMMENDED_PROPERTIES,
    SET_POPULAR_DESTINATIONS,
    SET_INFOGRAPHIC_BOXES,
    SET_DESTINATIONS_DISCOVERY,
    SET_DESTINATION_RECOMMENDATIONS,
    SET_AFFINITIES
} from '../actions/action-types';

export default (state = {}, action) => {
    switch (action.type) {
        case SET_DESTINATION_URGENCY_MESSAGE:
            return {
                ...state,
                urgencyMessage: action.payload
            };
        case SET_DESTINATION_INFOGRAPHIC:
            return {
                ...state,
                infographic: action.payload
            };
        case SET_UNIT_REVIEWS:
            return {
                ...state,
                reviews: action.payload
            };
        case SET_LISTINGS:
            return {
                ...state,
                segmentFilters: {
                    ...state.segmentFilters,
                    inventoryCount: action.inventoryCount,
                    loading: false
                },
                listings: action.listings,
                lastCardUrl: action.lastCardUrl,
                cachedListings: action.cachedListings
            };
        case LOADING_LISTINGS:
            return {
                ...state,
                segmentFilters: {
                    ...state.segmentFilters,
                    failed: false,
                    loading: true,
                    key: action.segmentKey,
                    timeoutMs: action.timeoutMs
                }
            };
        case FAILED_LISTINGS:
            return {
                ...state,
                segmentFilters: {
                    ...state.segmentFilters,
                    loading: false,
                    failed: true,
                    timeoutMs: state.segmentFilters.timeoutMs * 2
                }
            };
        case SET_DESTINATION_IMAGES:
            return {
                ...state,
                destinationImages: action.payload
            };
        case SET_POPULAR_DESTINATIONS:
            return {
                ...state,
                popularOriginDestinations: action.payload
            };
        case SET_DESTINATIONS_DISCOVERY:
            return {
                ...state,
                destinationsDiscovery: action.payload
            };
        case SET_DESTINATION_RECOMMENDATIONS:
            return {
                ...state,
                destinationRecommendations: action.payload
            };
        case SET_RECOMMENDED_PROPERTIES:
            return {
                ...state,
                recommendedProperties: action.payload
            };
        case SET_INFOGRAPHIC_BOXES:
            return {
                ...state,
                infographicBoxes: action.payload
            };
        case SET_AFFINITIES:
            return {
                ...state,
                affinities: action.payload
            };
        default:
            return state;
    }
};
